export const planUserVisibilityStyles = {
  container: {
    width: '100%',
  },
};
